import script from "./dimension-upsell.vue?vue&type=script&setup=true&lang=ts"
export * from "./dimension-upsell.vue?vue&type=script&setup=true&lang=ts"

import "./dimension-upsell.vue?vue&type=style&index=0&id=02caabcc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02caabcc"]])

export default __exports__